import Badge from '@/components/common/Badge';
import type { UserStatus } from '@/types';

const config: Record<UserStatus, { label: string; variant: 'warning' | 'success' | 'error' | 'default' }> = {
  pending:     { label: 'Pending',     variant: 'warning' },
  approved:    { label: 'Approved',    variant: 'success' },
  rejected:    { label: 'Rejected',    variant: 'error' },
  deactivated: { label: 'Deactivated', variant: 'default' },
};

export default function UserStatusBadge({ status }: { status: UserStatus }) {
  const { label, variant } = config[status];
  return <Badge label={label} variant={variant} dot />;
}
